<div *ngIf="isAlert12hour" class="warning-alert-notification-style">
    <mat-icon mat-dialog-close (click)="toggleChange()" class="mat-dialog-close">close</mat-icon>
    At least one of the selected shifts is within <strong>12 hours</strong>. 
    We are here for you and will do everything we can to fill these shifts on short notice. 
    To help us accomplish this, the applicable shift(s) will have a 15% processing fee.
</div>